import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const chatiwinBase: BrandBase = {
  id: `chatiwin`,
  domain: `chatiwin.com`,
  email: `support@chatiwin.com`,
  theme: `brightPink`,
  backgroundId: `elegant`,
  adsenseId: null,
  micrositeTheme: createMicrositeTheme({
    id: `chatiwin`,
    name: `Chatiwin Microsite`,
    palette: {
      primary: `#ec4899`,
      secondary: `#c026d3`,
      accent: `#f472b6`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #c026d3, #ec4899)`,
      sectionLight: `linear-gradient(135deg, rgba(255, 240, 247, 0.97), rgba(253, 242, 248, 0.92))`,
      sectionDark: `linear-gradient(160deg, #16051c, #290b3a 45%, #3b0b3d 90%)`,
      primaryCta: `linear-gradient(120deg, #f472b6 0%, #ec4899 45%, #facc15 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #f472b6 0%, #ec4899 45%, #facc15 100%)`,
        glow: `rgba(236, 72, 153, 0.45)`,
        shadow: `0 32px 70px rgba(236, 72, 153, 0.4)`,
      },
    },
  }),
  hostRedirects: {
    'www.chatiwin.com': `chatiwin.com`,
  },
  manifest: {
    name: `Chatiwin - Anonymous Chat Rooms | No Registration Required`,
    short_name: `Chatiwin`,
    description: `Anonymous chat rooms with complete privacy. No registration required. Free private messaging with encryption.`,
    theme_color: `#c2185b`,
    background_color: `#ffffff`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://chatiwin.com`,
    uat: `https://dev.chatiwin.com`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `anonymous chat, private messaging, chat rooms, instant chat, no signup, Chatiwin`,
    author: `Chatiwin`,
  },
  social: {
    title: `Chatiwin - Anonymous Chat Rooms | No Registration Required`,
    image: `/icon.png`,
  },
};
